(function() {
  'use strict';

  // Worker próprio (proxy da Frenet) — o token fica no worker, não aqui
  const QUOTE_ENDPOINT = 'https://bigmad-frete.sitebigmad.workers.dev/';

  function init() {
    document.querySelectorAll('[data-shipcalc]').forEach(setup);
  }

  function setup(root) {
    const input = root.querySelector('[data-shipcalc-cep]');
    const btn = root.querySelector('[data-shipcalc-btn]');
    const results = root.querySelector('[data-shipcalc-results]');
    const btnText = root.querySelector('[data-shipcalc-btn-text]');
    if (!input || !btn || !results) return;

    // Máscara de CEP
    input.addEventListener('input', () => {
      let v = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    });

    // CEP salvo de cotações anteriores
    try {
      const saved = localStorage.getItem('bigmad_cep');
      if (saved) input.value = saved;
    } catch (e) {}

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') { e.preventDefault(); quote(); }
    });
    btn.addEventListener('click', quote);

    // Quantidade na página de produto: limpa o resultado quando muda
    const productQty = document.querySelector('input[name="quantity"]');
    if (productQty) {
      productQty.addEventListener('change', () => {
        if (results.innerHTML !== '') {
          results.innerHTML = '<p class="bigmad-shipcalc-days">Quantidade alterada — calcule novamente.</p>';
        }
      });
    }

    function getQuantity() {
      const qtyInput = document.querySelector('input[name="quantity"]');
      if (!qtyInput) return 1;
      return Math.max(1, parseInt(qtyInput.value, 10) || 1);
    }

    // Carrinho: lista de itens (peso + medidas reais de cada um) gerada pelo Liquid
    function getCartItems() {
      const script = root.querySelector('[data-shipcalc-items]');
      if (!script) return null;
      try {
        const items = JSON.parse(script.textContent);
        if (!Array.isArray(items) || items.length === 0) return null;
        return items.map(it => ({
          Height: parseFloat(it.Height) || parseFloat(root.dataset.height) || 10,
          Length: parseFloat(it.Length) || parseFloat(root.dataset.length) || 30,
          Width: parseFloat(it.Width) || parseFloat(root.dataset.width) || 30,
          Weight: parseFloat(it.Weight) || 1,
          Quantity: Math.max(1, parseInt(it.Quantity, 10) || 1),
          SKU: it.SKU || ''
        }));
      } catch (e) {
        return null;
      }
    }

    async function quote() {
      const cep = input.value.replace(/\D/g, '');
      if (cep.length !== 8) {
        results.innerHTML = '<p class="bigmad-shipcalc-error">Digite um CEP válido.</p>';
        return;
      }

      try { localStorage.setItem('bigmad_cep', input.value); } catch (e) {}

      btn.disabled = true;
      if (btnText) btnText.textContent = 'Calculando...';
      results.innerHTML = '';

      // Carrinho: vários itens com medidas reais. Produto: 1 item × quantidade.
      const cartItems = getCartItems();
      let shippingItems, invoiceValue;

      if (cartItems) {
        shippingItems = cartItems;
        invoiceValue = parseFloat(root.dataset.value) || 0;
      } else {
        const qty = getQuantity();
        invoiceValue = (parseFloat(root.dataset.value) || 0) * qty;
        shippingItems = [{
          Height: parseFloat(root.dataset.height) || 10,
          Length: parseFloat(root.dataset.length) || 30,
          Width: parseFloat(root.dataset.width) || 30,
          Weight: parseFloat(root.dataset.weight) || 1,
          Quantity: qty,
          SKU: root.dataset.sku || ''
        }];
      }

      const payload = {
        SellerCEP: (root.dataset.originCep || '').replace(/\D/g, ''),
        RecipientCEP: cep,
        ShipmentInvoiceValue: invoiceValue,
        ShippingServiceCode: null,
        RecipientCountry: 'BR',
        ShippingItemArray: shippingItems
      };

      try {
        const res = await fetch(QUOTE_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        });

        if (!res.ok) {
          const errText = await res.text();
          throw new Error('HTTP ' + res.status + ' — ' + errText.slice(0, 200));
        }
        const data = await res.json();

        // Mensagem de erro que a API retorna mesmo com status 200
        if (data.Message) {
          throw new Error('API: ' + data.Message);
        }

        // A API da Frenet retorna "ShippingSevicesArray" (typo deles mesmo)
        const services = (data.ShippingSevicesArray || [])
          .filter(s => !s.Error && s.ShippingPrice)
          .sort((a, b) => parseFloat(a.ShippingPrice) - parseFloat(b.ShippingPrice));

        if (services.length === 0) {
          results.innerHTML = '<p class="bigmad-shipcalc-error">Nenhuma opção de frete encontrada para esse CEP.</p>';
          return;
        }

        results.innerHTML = services.map(s => {
          const price = parseFloat(s.ShippingPrice).toFixed(2).replace('.', ',');
          const days = s.DeliveryTime ? `${s.DeliveryTime} dia${s.DeliveryTime > 1 ? 's' : ''} úteis` : '';
          return `
            <div class="bigmad-shipcalc-row">
              <div class="bigmad-shipcalc-service">
                <span class="bigmad-shipcalc-name">${s.ServiceDescription || s.Carrier}</span>
                ${days ? `<span class="bigmad-shipcalc-days">${days}</span>` : ''}
              </div>
              <span class="bigmad-shipcalc-price">R$ ${price}</span>
            </div>
          `;
        }).join('');

      } catch (err) {
        console.error('Frete error:', err);
        results.innerHTML = '<p class="bigmad-shipcalc-error">Erro: ' + (err && err.message ? err.message : 'desconhecido') + '</p>';
      } finally {
        btn.disabled = false;
        if (btnText) btnText.textContent = 'Calcular';
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
